module.exports = __webpack_public_path__ + "static/media/feature-3.filter.26505474.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/feature-3.filter.jpeg
// module id = 293
// module chunks = 21